import { render, staticRenderFns } from "./CustomTranslationModal.vue?vue&type=template&id=9f8ba58e"
import script from "./CustomTranslationModal.vue?vue&type=script&lang=js"
export * from "./CustomTranslationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports